import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Loader2, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setResult(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto flex min-h-screen max-w-[700px] items-center px-6 py-12">
      <div className="w-full border border-[#222] bg-[#0A0A0B] p-10">
        <Link to="/" className="font-display text-3xl tracking-widest">
          <span className="text-[#FF003C]">V</span>OLT<span className="text-[#FFE800]">.</span>MV
        </Link>
        <div className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-[#FFE800]">// PASSWORD RESET</div>
        <h1 className="mt-2 font-display text-5xl leading-none">Forgot Password</h1>

        {result?.ok ? (
          <div className="mt-8">
            <div className="border border-[#00F0FF] bg-[#00F0FF]/10 p-4 text-sm text-[#c8c8c8]" data-testid="forgot-result">
              {result.message}
            </div>
            {result.dev_reset_link && (
              <div className="mt-4 border border-[#FFE800] bg-[#FFE800]/5 p-4 font-mono text-xs">
                <div className="mb-1 uppercase tracking-widest text-[#FFE800]">DEV MODE — no mail provider configured</div>
                <a
                  href={result.dev_reset_link}
                  data-testid="forgot-dev-link"
                  className="break-all text-white underline hover:text-[#FF003C]"
                >
                  {result.dev_reset_link}
                </a>
              </div>
            )}
            <Link to="/login" className="btn-brutal mt-6 inline-flex">
              Back to Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-form">
            <label className="block">
              <div className="mb-1 font-mono text-[10px] uppercase tracking-widest text-[#808080]">Email</div>
              <input
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-[#222] bg-[#050505] p-3 font-mono text-sm text-white outline-none focus:border-[#FF003C]"
                placeholder="you@example.com"
              />
            </label>
            {error && (
              <div className="border border-[#FF003C] p-3 font-mono text-xs text-[#FF003C]">{error}</div>
            )}
            <button data-testid="forgot-submit" type="submit" disabled={loading} className="btn-brutal w-full">
              {loading ? <Loader2 className="animate-spin" size={16} /> : <Mail size={16} />}
              Send Reset Link
            </button>
            <Link to="/login" className="block text-center font-mono text-xs uppercase tracking-widest text-[#808080] hover:text-white">
              Back to sign in
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
